import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isNullOrEmpty } from '@awp/core/utils';

export function isInRange(value: number | string, min: number, max: number): boolean {
  let num: number = null;

  if (typeof value === 'string') {
    num = Number(value);
  } else {
    num = value;
  }

  return (num >= min && num <= max);
}

const NUMERIC_REGEX = /^[0-9]*$/;

export class NumberValidator {

  static isNumeric(control: FormControl): ValidationErrors | null {
    if (isNullOrEmpty(control.value)) {
      return null;
    }
    return NUMERIC_REGEX.test(control.value) ? null : { invalid: true };
  }

  static range(min: number, max: number): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
      const value = typeof control.value === 'number' ? control.value : Number(control.value);
      if (value != null && (isNaN(value) || value < min || value > max)) {
        return { 'range': true };
      } else {
        return null;
      }
    };
  }

}

